export default [
  {
    navId: "admin-item-master",
    title: "Master Data",
    icon: "ToolIcon",
    children: [
      {
        navId: "admin-item",
        title: "Item Master",
        route: "item",
        icon: "ToolIcon",
      },
      {
        navId: "admin-item-bundles",
        title: "Bundles Master",
        route: "bundles",
        icon: "ToolIcon",
      },
      {
        navId: "admin-dealer",
        title: "Dealer Master",
        route: "dealer",
        icon: "ToolIcon",
      },
      {
        navId: "admin-postal",
        title: "POS Code Master",
        route: "post-code",
        icon: "ToolIcon",
      },
      {
        navId: "admin-industry-type",
        title: "Industry Type",
        route: "industry-type",
        icon: "ToolIcon",
      },
      {
        navId: "admin-product-hierarchy",
        title: "PH Mapping Master",
        route: "master-ph",
        icon: "ToolIcon",
      },
      {
        navId: "admin-sparepart-category",
        title: "Sparepart Category",
        route: "sparepart-category",
        icon: "ToolIcon",
      },
      {
        navId: "admin-accessories-category",
        title: "Accessories Category",
        route: "accessories-category",
        icon: "ToolIcon",
      },
      {
        navId: "admin-sparepart-master",
        title: "Sparepart Master",
        route: "sparepart-master",
        icon: "ToolIcon",
      },
    ],
  },

  {
    navId: "warranty-menus",
    title: "Warranty",
    icon: "FileTextIcon",
    children: [
      {
        navId: "admin-equipment-warranty",
        title: "Applied Equipment",
        route: "equipment-warranty",
        icon: "FileTextIcon",
      },
      {
        navId: "admin-project-warranty",
        title: "Project Warranty",
        route: "project-warranty",
        icon: "FileTextIcon",
      },
      {
        navId: "admin-warranty-external",
        title: "Paperless Warranty",
        route: "paperless-warranty",
        icon: "FileTextIcon",
      },
      {
        navId: "warranty-status",
        title: "Warranty Status",
        route: "warranty-status",
        icon: "FileTextIcon",
      },
      {
        navId: "admin-all-warranty",
        title: "All Reg. Warranty",
        route: "all-warranty",
        icon: "FileTextIcon",
      },
      {
        navId: "admin-pending-review-warranty",
        title: "Pending Review",
        route: "pending-review",
        icon: "FileTextIcon",
      },
    ],
  },
  {
    navId: "admin-warranty-master",
    title: "Warranty Master",
    icon: "AlignJustifyIcon",

    children: [
      {
        navId: "admin-base-warranty",
        title: "Base Warranty",
        route: "base-warranty",
        icon: "AlignJustifyIcon",
      },
      {
        navId: "admin-option-warranty",
        title: "Option Warranty",
        route: "option-warranty",
        icon: "AlignJustifyIcon",
      },
      {
        navId: "admin-compressor-warranty",
        title: "Compressor Warranty",
        route: "compressor-warranty",
        icon: "AlignJustifyIcon",
      },

      {
        navId: "admin-pcode",
        title: "PCode",
        route: "pcode",
        icon: "AlignJustifyIcon",
      },
      {
        navId: "admin-campaign",
        title: "Campaign",
        route: "campaign",
        icon: "AlignJustifyIcon",
      },
      {
        navId: "admin-promo-code",
        title: "Promo Code Batch",
        route: "promo-code",
        icon: "AlignJustifyIcon",
      },
      {
        navId: "system-promo",
        title: "System Promo",
        icon: "AlignJustifyIcon",
        route: "system-promo",
      },
      {
        navId: "term-condition",
        title: "Terms and Condition",
        icon: "AlignJustifyIcon",
        route: "terms-condition",
      },
    ],
  },
  {
    navId: "admin-inventory",
    title: "Inventory",
    icon: "CheckCircleIcon",

    children: [
      {
        navId: "admin-inventory-all",
        title: "View Inventory",
        route: "view-inventory",
        icon: "CheckCircleIcon",
      },
      {
        navId: "dealer-inventory",
        title: "Inventory Dealer",
        route: "inventory-dealer",
        icon: "CheckCircleIcon",
      },
      {
        navId: "admin-top-10-sparepart",
        title: "Top 10 Sparepart",
        route: "top-10-sparepart",
        icon: "CheckCircleIcon",
      },
    ],
  },
  {
    navId: "delivery-orders",
    title: "Delivery Orders",
    icon: "HomeIcon",
    children: [
      {
        navId: "delivery-orders-daikin",
        title: "Daikin Warehouse",
        route: "delivery-orders-daikin",
        icon: "HomeIcon",
      },
      {
        navId: "delivery-orders-sumitomo",
        title: "Sumitomo Warehouse",
        route: "delivery-orders-sumitomo",
        icon: "HomeIcon",
      },
      {
        navId: "delivery-orders-ekiosk",
        title: "eKiosk Warehouse",
        route: "delivery-orders-ekiosk",
        icon: "HomeIcon",
      },
    ],
  },
  {
    navId: "admin-shipping",
    title: "Shipping",
    icon: "TruckIcon",
    children: [
      {
        navId: "shipping-daikin",
        title: "Daikin Warehouse",
        route: "shipping-daikin",
        icon: "TruckIcon",
      },
      {
        navId: "shipping-sumitomo",
        title: "Sumitomo Warehouse",
        route: "shipping-sumitomo",
        icon: "TruckIcon",
      },
      // {
      //   navId: "shipping-ekiosk",
      //   title: "eKiosk Warehouse",
      //   route: "shipping-ekiosk",
      //   icon: "TruckIcon",
      // },
    ],
  },
  {
    navId: "self_collect",
    title: "Self Collect",
    icon: "PackageIcon",
    children: [
      {
        navId: "self-collect-daikin",
        title: "Daikin Warehouse",
        route: "self-collect-daikin",
        icon: "PackageIcon",
      },
      {
        navId: "self-collect-sumitomo",
        title: "Sumitomo Warehouse",
        route: "self-collect-sumitomo",
        icon: "PackageIcon",
      },
      {
        navId: "self-collect-ekiosk",
        title: "eKiosk Warehouse",
        route: "self-collect-ekiosk",
        icon: "PackageIcon",
      },
    ],
  },
  {
    navId: "admin-return-delivery",
    title: "Return Delivery",
    icon: "ArrowLeftCircleIcon",
    children: [
      {
        navId: "return-delivery-daikin",
        title: "Daikin Warehouse",
        route: "return-delivery-daikin",
        icon: "ArrowLeftCircleIcon",
      },
      {
        navId: "return-delivery-sumitomo",
        title: "Sumitomo Warehouse",
        route: "return-delivery-sumitomo",
        icon: "ArrowLeftCircleIcon",
      },
      {
        navId: "return-delivery-ekiosk",
        title: "eKiosk Warehouse",
        route: "return-delivery-ekiosk",
        icon: "ArrowLeftCircleIcon",
      },
    ],
  },
  {
    navId: "manual-return-delivery",
    title: "Manual Return",
    icon: "RewindIcon",
    children: [
      {
        navId: "manual-return-delivery-daikin",
        title: "Daikin Warehouse",
        route: "manual-return-delivery-daikin",
        icon: "ArrowLeftCircleIcon",
      },
      {
        navId: "manual-return-delivery-sumitomo",
        title: "Sumitomo Warehouse",
        route: "manual-return-delivery-sumitomo",
        icon: "ArrowLeftCircleIcon",
      },
      {
        navId: "manual-return-delivery-ekiosk",
        title: "eKiosk Warehouse",
        route: "manual-return-delivery-ekiosk",
        icon: "ArrowLeftCircleIcon",
      },
    ],
  },
  {
    navId: "admin-redelivery",
    title: "Redelivery",
    icon: "RefreshCcwIcon",
    children: [
      {
        navId: "redelivery-daikin",
        title: "Daikin Warehouse",
        route: "redelivery-daikin",
        icon: "RefreshCcwIcon",
      },
      {
        navId: "redelivery-sumitomo",
        title: "Sumitomo Warehouse",
        route: "redelivery-sumitomo",
        icon: "RefreshCcwIcon",
      },
      // {
      //   navId: "redelivery-ekiosk",
      //   title: "eKiosk Warehouse",
      //   route: "redelivery-ekiosk",
      //   icon: "RefreshCcwIcon",
      // },
    ],
  },
  {
    navId: "admin-kiosk-warehouse",
    title: "Kiosk Warehouse",
    icon: "HomeIcon",
    children: [
      {
        navId: 'kiosk-dashboard',
        title: 'Kiosk Dashboard',
        route: 'kiosk-dashboard',
        icon: 'HomeIcon',
      },
      {
        navId: 'kiosk-warehouse',
        title: 'Kiosk Warehouse',
        route: 'kiosk-warehouse',
        icon: 'HomeIcon',
      },
    ],
  },
  {
    navId: 'admin-kiosk-kpi',
    title: 'Kiosk KPI',
    icon: 'BarChart2Icon',
    children: [
      {
        navId: 'ekiosk-kpi-dashboard',
        title: 'eKiosk KPI Dashboard',
        route: 'ekiosk-kpi-dashboard',
        icon: 'BarChart2Icon',
      },
      {
        navId: 'ekiosk-kpi-past-3-years-dashboard',
        title: 'Past 3 Years Dashboard',
        route: 'ekiosk-kpi-past-3-years-dashboard',
        icon: 'BarChart2Icon',
      },
      {
        navId: 'ekiosk-kpi-report',
        title: 'eKiosk KPI Report',
        route: 'ekiosk-kpi-report',
        icon: 'FileTextIcon',
      },
      {
        navId: 'ekiosk-kpi-master',
        title: 'KPI master',
        route: 'ekiosk-kpi-master',
        icon: 'SettingsIcon',
      },
    ],
  },
  {
    navId: "admin-retrigger-api",
    title: "Retrigger API",
    icon: "RotateCwIcon",
    children: [
      {
        navId: "resend-to-sap",
        title: "Resend to SAP",
        route: "resend-to-sap",
        icon: "RotateCwIcon",
      },
    ],
  },
  {
    navId: "admin-manual-create",
    title: "Manual Create",
    icon: "PlusIcon",
    children: [
      {
        navId: "manual-create-delivery",
        title: "Delivery Order",
        route: "manual-create-delivery",
        icon: "PlusIcon",
      },
      {
        navId: "manual-create-inventory",
        title: "Inventory",
        route: "manual-create-inventory",
        icon: "PlusIcon",
      },
      {
        navId: "manual-create-by-upload",
        title: "By Upload",
        route: "manual-create-by-upload",
        icon: "PlusIcon",
      },
    ],
  },
  {
    navId: "admin-counter",
    title: "Counter",
    icon: "MonitorIcon",
    children: [
      {
        navId: "counter-daikin",
        title: "Counter Daikin",
        route: "counter-daikin",
        icon: "HomeIcon",
      },
      {
        navId: 'kiosk-po-counter',
        title: 'Kiosk PO Counter',
        route: 'kiosk-po-counter',
        icon: 'ShoppingCartIcon',
      },
    ],
  },
  {
    navId: "admin-utility-tools",
    title: "Utility Tools",
    icon: "EditIcon",
    children: [
      {
        navId: "mass-do-update",
        title: "Mass DO Update",
        route: "mass-do-update",
        icon: "EditIcon",
      },
      {
        navId: "transaction-log-record",
        title: "Transaction Log Record",
        route: "transaction-log-record",
        icon: "EditIcon",
      },
      {
        navId: "edit-do-status",
        title: "Edit DO Status",
        route: "edit-do-status",
        icon: "EditIcon",
      },
      {
        navId: "clear-amk-spare-part",
        title: "Clear Amk Spare Part",
        route: "clear-amk-spare-part",
        icon: "EditIcon",
      },
      {
        navId: "mass-update-email",
        title: "Mass Update email",
        route: "mass-update-email",
        icon: "EditIcon",
      },{
        navId: "return-order-type-exception",
        title: "Return Order Type Exception",
        route: "return-order-type-exception",
        icon: "EditIcon",
      },{
        navId: "manual-return-order-type",
        title: "Order Type For Manual Return",
        route: "manual-return-order-type",
        icon: "EditIcon",
      },
      {
        navId: "replace-do",
        title: "DO Replacement",
        route: "replace-do",
        icon: "EditIcon",
      },
      {
        navId: "bulk-update-warranty",
        title: "Bulk Update Warranty",
        route: "bulk-update-warranty",
        icon: "EditIcon",
      },
    ],
  },
  {
    navId: "admin-settings",
    title: "Settings",
    icon: "SettingsIcon",

    children: [
      {
        navId: "role",
        title: "Role",
        route: "role",
        icon: "UserCheckIcon",
      },
      {
        navId: "admin-users-admin",
        title: "User Management",
        route: "user-management",
        icon: "UsersIcon",
      },
      {
        navId: "admin-ekiosk-users-admin",
        title: "Ekiosk User Management",
        route: "ekiosk-user-management",
        icon: "UsersIcon",
      },
      {
        navId: "admin-holidays",
        title: "Holiday Management",
        route: "holiday-management",
        icon: "SunIcon",
      },
      {
        navId: "admin-dashboard-password",
        title: "Dashboard Password",
        route: "dashboard-password",
        icon: "MonitorIcon",
      },
      // {
      //   navId: "admin-kiosk-password",
      //   title: "Kiosk Password",
      //   route: "kiosk-password",
      //   icon: "MonitorIcon",
      // },
      {
        navId: "admin-gst",
        title: "GST",
        route: "gst",
        icon: "UsersIcon",
      },
      {
        navId: "admin-discount",
        title: "Discount",
        route: "discount",
        icon: "PercentIcon",
      },
      // {
      //   navId: "admin-ticketing-text",
      //   title: "Ticketing Text",
      //   route: "ticketing-text",
      //   icon: "MonitorIcon",
      // },
      {
        navId: "admin-kiosk-settings",
        title: "Kiosk Settings",
        route: "kiosk-settings",
        icon: "MonitorIcon",
      },

    ],
  },

  {
    navId: "report-menus",
    title: "Report",
    icon: "ListIcon",

    children: [
      {
        navId: "report-inventory",
        title: "Inventory Report",
        route: "inventory-report",
        icon: "ListIcon",
      },
      {
        navId: "report-rsp-order",
        title: "RSP Order Report",
        route: "rsp-order-report",
        icon: "ListIcon",
      },
      {
        navId: "report-pcode",
        title: "PCode History Report",
        route: "pcode-report",
        icon: "ListIcon",
      },
      {
        navId: "report-promo-code",
        title: "Promo Code Report",
        route: "promo-code-report",
        icon: "ListIcon",
      },
      {
        navId: "report-do",
        title: "DO Report",
        route: "do-report",
        icon: "ListIcon",
      },
      {
        navId: "report-expiring-warranty",
        title: "Expiring Warranty Report",
        route: "expiring-warranty-report",
        icon: "ListIcon",
      },
      {
        navId: "report-expired-warranty",
        title: "Expired Warranty Report",
        route: "expired-warranty-report",
        icon: "ListIcon",
      },
      {
        navId: "report-skip-scan",
        title: "Skip Scan Report",
        route: "skip-scan-report",
        icon: "ListIcon",
      },
      {
        navId: "report-all-warranty",
        title: "All Warranty Report",
        route: "all-warranty-report",
        icon: "ListIcon",
      },
      {
        navId: "report-return",
        title: "Return Report",
        route: "return-report",
        icon: "ListIcon",
      },
    ],
  },
  {
  navId: "ekiosk-report-menus",
  title: "eKiosk Report",
  icon: "ListIcon",
  children: [
    {
      navId: "ekiosk-online-order-report",
      title: "Online Order",
      route: "ekiosk-online-order-report",
      icon: "ListIcon",
    },
    {
      navId: "ekiosk-counter-order-report",
      title: "Counter Order",
      route: "ekiosk-counter-order-report",
      icon: "ListIcon",
    },
    {
      navId: "ekiosk-rsp-dealer-order-report",
      title: "RSP Dealer Order",
      route: "ekiosk-rsp-dealer-order-report",
      icon: "ListIcon",
    },
    {
      navId: "ekiosk-warehouse-report",
      title: "Warehouse Report",
      route: "ekiosk-warehouse-report",
      icon: "ListIcon",
    },
  ],
},
];
